import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(async (nuxtApp: any) => {
  const Quill = (await import('quill')).default;

  nuxtApp.provide('quill', Quill);
});
